module.exports = __webpack_public_path__ + "static/calloutVisual-f9477abbb12cf5c0075d36edcef1ed54.jpg";